import { render, staticRenderFns } from "./ModalCreatePurchase.vue?vue&type=template&id=8f66100a"
import script from "./ModalCreatePurchase.vue?vue&type=script&lang=js"
export * from "./ModalCreatePurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports